import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import StyledMap from './Map.styles';
import Marker from './Marker';


const Map = ({ restaurants, zipCode,typedLat,typedLng, setTypedLat, setTypedLng,selectedLat,setSelectedLat,selectedLng,setSelectedLng,initLat,setInitLat,initLng,setInitLng,userSelectedPin,setUserSelectedPin }) => {

  const [map, setMap] = useState(null);
  const [geoLat, setGeoLat] = useState('')
  const [geoLng, setGeoLng] = useState('')
  
  // const [typedLat, setTypedLat] = useState()
  // const [typedLng, setTypedLng] = useState()
  const [selectedPin, setSelectedPin] = useState(false)
  
  const [newZip, setNewZip] = useState();

  useEffect(() => {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    function success(pos) {
      var crd = pos.coords;

      
      setGeoLat(crd.latitude);
      setGeoLng(crd.longitude);
      // setSelectedLat(crd.latitude);
      // setSelectedLng(crd.longitude);
      console.log(`More or less ${crd.accuracy} meters.`);
      console.log('first,crd', crd)

    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    navigator.geolocation.getCurrentPosition(success, error, options);
    
  }, [])

  useEffect(() => {
    if(navigator.geolocation) {
      const getZip = function(cb) {
        if (document.location.protocol === 'http:' && (navigator.geolocation != null)) {
          return navigator.geolocation.getCurrentPosition(function(pos) {
           
           let coords = pos.coords;
            let url2 = `http://nominatim.openstreetmap.org/reverse?format=json&lat=${coords.latitude}&lon=${coords.longitude}&addressdetails=1`;
            fetch(url2)
            .then(res => res.json())
            .then(data => setNewZip(data?.address?.postcode))
            .catch(err => console.err(err))
           
          });
        }
      };
      getZip();
  }
  }, [])
  
  
    useEffect(() => {
   
      const getCordinatesFromZip = function(cb) {
       
            // let zippycode = zipCode;
            let urlZip = `https://nominatim.openstreetmap.org/search.php?q=${zipCode}&countrycodes=US&format=jsonv2`;
           zipCode.length === 5 && fetch(urlZip)
            .then(res => res.json())
            .then(data =>{ 
              setTypedLat(data[0].lat);
              setTypedLng(data[0].lon);
            }
              )
            .catch(err => console.err(err))
           
          
        
      };
      getCordinatesFromZip();
  
  }, [zipCode,setTypedLat,setTypedLng,typedLat,typedLng])
  const defaultProps = {
    center: {
      lat: selectedLat,
      lng: selectedLng
    },
    zoom: 9
  };
  
  return (
    // Important! Always set the container height explicitly
    <StyledMap>
      {/* <p style={{marginTop:'-1em'}}> user's lat,lng: {geoLat},{geoLng}</p>
      <h3> selected: {selectedLat},{selectedLng}</h3> */}
      <div className="google-map-container">
        {/* <h1>{zipCode}, typedLat:{typedLat}, typedLng:{typedLng}</h1> */}
        <GoogleMapReact
          bootstrapURLKeys={{ key: 'AIzaSyAw3e8QWVoj7sfa9pihMFCJtpydx4QM2_w' }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
          center={{
            lat: selectedLat,
            lng: selectedLng
          }}

        >
          {restaurants.map((place, index) => (
            <Marker
              key={`marker-${index}`}
              text={place.city}
              lat={place.latitude}
              lng={place.longitude}
              selectedLat={selectedLat}
              selectedLng={selectedLng}
              setSelectedLat={setSelectedLat}
              setSelectedLng={setSelectedLng}
            />
          ))}
        </GoogleMapReact>
      </div>
    </StyledMap>
  );

}

export default Map;